<template>
  <div class="issue-page">
    <div class="issue-header">
      卷号一览
    </div>

    <div
      class="issue-row"
      v-for="(item, index) in issueList"
      :key="index"
      @click="goToIssueCatalog(item)"
    >
      <span class="issue-title">
        {{ item.year }}年{{ item.period }}
      </span>

      <span class="issue-date">
        公开时间：{{ item.publishDate }}
      </span>
    </div>
  </div>
</template>

<script>
import { fuzzySearch } from '@/api/data'

export default {
  name: 'manuscriptsIssueList',

  data () {
    return {
      issueList: []
    }
  },

  mounted () {
    this.getIssueList()
  },

  methods: {
    getIssueList () {
      const currentYear = new Date().getFullYear()
      const years = []

      for (let year = currentYear; year >= currentYear - 4; year--) {
        years.push(year)
      }

      const yearRequests = years.map(year => {
        const searchParams = {
          year: `${year}-01-01 00:00:00`,
          period: '',
          title: null,
          authorName: null,
          authorUint: null,
          keywords: null,
          manuscriptGroup: '',
          current: 1,
          size: 10
        }

        return fuzzySearch(searchParams).then(res => {
          if (
            !res.data ||
            res.data.errorCode !== 0 ||
            !res.data.result
          ) {
            return []
          }

          const result = res.data.result
          const firstPageRecords = result.records || []
          const totalPages = result.pages || 1

          if (totalPages <= 1) {
            return firstPageRecords
          }

          const pageRequests = []

          for (let page = 2; page <= totalPages; page++) {
            pageRequests.push(
              fuzzySearch({
                ...searchParams,
                current: page
              })
            )
          }

          return Promise.all(pageRequests).then(responses => {
            let allRecords = [...firstPageRecords]

            responses.forEach(response => {
              if (
                response.data &&
                response.data.errorCode === 0 &&
                response.data.result &&
                response.data.result.records
              ) {
                allRecords = allRecords.concat(
                  response.data.result.records
                )
              }
            })

            return allRecords
          })
        })
      })

      Promise.all(yearRequests).then(yearResults => {
        let allRecords = []

        yearResults.forEach(records => {
          allRecords = allRecords.concat(records)
        })

        this.buildIssueList(allRecords)
      })
    },

    buildIssueList (records) {
      const issueMap = new Map()

      records.forEach(article => {
        if (!article.publishedTime || !article.period) {
          return
        }

        const year = article.publishedTime.substring(0, 4)
        const period = article.period
        const key = `${year}-${period}`

        if (!issueMap.has(key)) {
          issueMap.set(key, {
            year: year,
            period: period,
            publishDate: article.publishedTime
              .substring(0, 10)
              .replace(/-/g, '/')
          })
        }
      })

      this.issueList = Array.from(issueMap.values()).sort((a, b) => {
        if (Number(a.year) !== Number(b.year)) {
          return Number(b.year) - Number(a.year)
        }

        const aPeriod =
          parseInt(String(a.period).replace(/\D/g, '')) || 0

        const bPeriod =
          parseInt(String(b.period).replace(/\D/g, '')) || 0

        return bPeriod - aPeriod
      })
    },

    goToIssueCatalog (issue) {
      this.$router.push({
        name: 'manuscriptsNewList',
        query: {
          year: issue.year,
          period: issue.period
        }
      })
    }
  }
}
</script>

<style scoped>
.issue-page {
  width: 70%;
  margin: 30px auto;
}

.issue-header {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
}

.issue-row {
  display: flex;
  justify-content: space-between;
  padding: 16px 10px;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
}

.issue-row:hover {
  background: #f5f5f5;
}

.issue-title {
  font-weight: bold;
}

.issue-date {
  color: #666;
}
</style>


// WEBPACK FOOTER //
// src/view/manuscriptsIssueList.vue